/*
 * Пакетные инструменты: два подзаголовка на разных пермишшенах.
 * Объединить их в один заголовок нельзя — header фильтруется по своему resource,
 * и при частичных правах пункты остались бы без подписи.
 */
export default [
  {
    header: 'Инструменты пакетов',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Собрать пак из файлов',
    route: 'pack-from-files',
    icon: 'FolderPlusIcon',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Поиск в Пакетах',
    route: 'packs-search',
    icon: 'ZoomInIcon',
    resource: 'db-music',
    action: 'view',
  },
  {
    header: 'Проверка Пакетов',
    resource: 'pack-review',
    action: 'view',
  },
  {
    title: 'Анализ Пакета',
    route: 'pack-analyze',
    icon: 'PieChartIcon',
    resource: 'pack-review',
    action: 'view',
  },
  {
    title: 'Проверка Пакета',
    route: 'pack-validate',
    icon: 'CheckSquareIcon',
    resource: 'pack-review',
    action: 'view',
  },
]
